import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/map1@lg.webp")